import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    chatId: string;
};

export const schemaChatResolver_GetChatLinkState = z
    .object({
        loanRequestIds: z.array(schemaId),
        partnerIds: z.array(schemaId),
        // Phone-shaped only (BSUID → null); partner links count only while it matches the partner's phone.
        phone: z.string().nullable(),
        phoneNumberId: z.string(),
    })
    .nullable();

export type SchemaChatResolver_GetChatLinkState = z.infer<typeof schemaChatResolver_GetChatLinkState>;

export type ChatResolver_GetChatLinkState = Resolver<Arguments, SchemaChatResolver_GetChatLinkState>;
